import { FirstMenu } from "./FirstMenu";
import { LogoTextSvgIcon } from "./LogoTextSvgIcon";

/** 头部左侧区域，组合品牌标识与一级菜单。 */
export function ToolBarLeft() {
    return (
        <div className="tool-bar-lf">
            <LogoTextSvgIcon />
            <FirstMenu />
        </div>
    );
}

export default ToolBarLeft;
